/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardBalance/_sections/Balance.js
 * Created:       Wed Mar 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Jul 08 2025
 */

import React from "react";
import { ProgressBar } from "../../../_components";
import { formatIntlMoney } from "../../../../_utils";
/**
 *
 * @param { condition } displayBalance
 *
 * @param { string } balance
 *
 * @param { string } inititalValue
 *
 * @returns Balance HTML
 */
export default function Balance({giftCard, settings}) {

  return giftCard && giftCard.balance ? (
    <>
      {formatIntlMoney(giftCard.balance, giftCard.currency, window?.Shopify?.locale || "en", settings.shop.money_format)}/{formatIntlMoney(giftCard.initial_value, giftCard.currency, window?.Shopify?.locale || "en", settings.shop.money_format)} {giftCard.currency}
      <ProgressBar fill={(giftCard.balance / giftCard.initial_value) * 100} />
    </>
  ) : (<></>);
}
